import LegalPage from "@/pages/LegalPage";
import { BRAND } from "@/lib/constants";

export default function Cookies() {
  return (
    <LegalPage
      overline="Cookiepolitik"
      title="Cookies på gudiksenstays.dk"
      sections={[
        {
          heading: "1. Hvad er cookies?",
          body: [
            "Cookies er små tekstfiler, som gemmes på din enhed, når du besøger en hjemmeside. De bruges bl.a. til at få siden til at fungere korrekt, huske dine valg og indsamle statistik om, hvordan siden bruges.",
          ],
        },
        {
          heading: "2. Hvilke cookies bruger vi?",
          body: [
            "Vi anvender to typer cookies:",
            [
              "Nødvendige cookies: Sikrer grundlæggende funktioner som sikkerhed, netværkshåndtering og at du kan navigere siden. Disse er altid aktive og kræver ikke samtykke.",
              "Statistik-cookies (PostHog): Hjælper os med at forstå, hvordan besøgende bruger siden – fuldt anonymt. Disse sættes kun, hvis du har givet samtykke via cookiebanneret.",
            ],
          ],
        },
        {
          heading: "3. Tredjepartstjenester",
          body: [
            "Følgende tredjeparter kan sætte cookies via vores side, hvis du har samtykket:",
            [
              "PostHog – anonym produktanalyse for at forbedre brugeroplevelsen.",
              "Calendly – hvis du booker et møde direkte i vores kalender, sætter Calendly egne cookies på deres domæne.",
            ],
          ],
        },
        {
          heading: "4. Sådan trækker du dit samtykke tilbage",
          body: [
            "Du kan til enhver tid trække dit samtykke tilbage ved at rydde din browsers cookies for gudiksenstays.dk. Herefter vil cookiebanneret vise sig igen næste gang du besøger siden, og du kan foretage et nyt valg.",
            "Du kan også afvise cookies direkte i din browsers indstillinger. Bemærk at nogle funktioner på siden kan blive begrænset, hvis nødvendige cookies afvises.",
          ],
        },
        {
          heading: "5. Kontakt",
          body: [
            `Har du spørgsmål til vores brug af cookies, er du velkommen til at kontakte os på ${BRAND.email} eller ${BRAND.phone}.`,
          ],
        },
      ]}
    />
  );
}
